const isEmpty = obj => Object.keys(obj).length === 0;

const isBusinessObjectiveMap = businessObjectives => {
  return !!businessObjectives && !isEmpty(businessObjectives);
};

export const isBusinessObjective = businessObjective => {
  return businessObjective && !isEmpty(businessObjective) && 'productApiName' in businessObjective;
};
export const businessObjectivesForApiName = ({
  businessObjectives
}, {
  apiName
}) => {
  if (isBusinessObjectiveMap(businessObjectives)) {
    return businessObjectives[apiName];
  }

  return {};
};
export const businessObjectivesForHighlightedProducts = ({
  businessObjectives
}, {
  highlightedProducts
}) => {
  if (!businessObjectives || !Object.keys(businessObjectives).length) return {};
  return highlightedProducts.reduce((acc, apiName) => {
    if (businessObjectives[apiName]) {
      acc[apiName] = businessObjectives[apiName];
    }

    return acc;
  }, {});
};